import axios2 from '../api/axios';
export const purchaseorderservices = {
    createpurchaseorder,
    getpurchaseOrder,
    setpurchaseOrder,
    purchaseorderEdit,
    editpurchaseorder,
    deletepurchaseorder,
    quickbookconnect,
    checkconnection,
    getpurchaseOrderspecific,
    createquickbookpurchaseorder,
    getpurchaseOrderreport,
    getpurchaseorderAnalytics
}


function createpurchaseorder(objdata){
    return axios2.post(`/purchaseordercreate`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getpurchaseOrder(ponumber = 'all',{ status = 'all',fromdate='',todate='' } = {},page, pageSize){
   return axios2.get(`/getpurchaseOrder?ponumber=${ponumber}&&status=${status}&fromdate=${fromdate}&todate=${todate}&page=${page}&limit=${pageSize}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function getpurchaseOrderreport(ponumber = 'all',{ status = 'all',fromdate = '',todate=''} = {}){
   return axios2.get(`/getpurchaseOrderreport?ponumber=${ponumber}&&status=${status}&fromdate=${fromdate}&todate=${todate}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function setpurchaseOrder(objdata){
   return axios2.post(`/setpurchaseOrder`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function purchaseorderEdit(ponumber){
    return axios2.get(`/purchaseorderEdit?ponumber=${ponumber}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function editpurchaseorder(objdata){
   return axios2.post(`/editpurchaseorder`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function deletepurchaseorder(id){
   return axios2.get(`/deletepurchaseorder?ponumber=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function quickbookconnect(){
   return axios2.get(`/qb/connect`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })     
}

function checkconnection(){
   return axios2.get(`/qb/checkconnection`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getpurchaseOrderspecific(ponumber){
   return axios2.get(`/getpurchaseOrderspecific?ponumber=${ponumber}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function createquickbookpurchaseorder(objdata){
   return axios2.get(`/qb/createpurchaseorder?ponumber=${objdata}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}


function getpurchaseorderAnalytics(){
   return axios2.get(`/getpurchaseorderAnalytics`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}







